// Utility functions for managing dynamic auth users
// This extends the static authUsers with dynamically created managers and agents

import { authUsers } from '../data/authUsers';

// In-memory store for dynamically created users
let dynamicAuthUsers = [];

// Get all auth users (static + dynamic)
export const getAllAuthUsers = () => {
    return [...authUsers, ...dynamicAuthUsers];
};

// Add a new auth user (for dynamically created managers/agents)
export const addAuthUser = (user) => {
    // Check if user already exists
    const exists = dynamicAuthUsers.find(u => u.email === user.email);
    if (exists) {
        // Update existing
        const index = dynamicAuthUsers.findIndex(u => u.email === user.email);
        dynamicAuthUsers[index] = { ...dynamicAuthUsers[index], ...user };
    } else {
        // Add new
        dynamicAuthUsers.push(user);
    }
    return user;
};

// Remove an auth user
export const removeAuthUser = (email) => {
    dynamicAuthUsers = dynamicAuthUsers.filter(u => u.email !== email);
};

// Find user by email and password
export const authenticateUser = (email, password) => {
    const allUsers = getAllAuthUsers();
    return allUsers.find(
        user => user.email === email && user.password === password
    );
};

// Generate random password
export const generatePassword = (length = 12) => {
    const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%';
    let password = '';
    for (let i = 0; i < length; i++) {
        password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return password;
};

// Generate referral code for agents
export const generateReferralCode = () => {
    const random = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
    return `APN-AGT-${random}`;
};

// Simulate sending credentials email
export const sendCredentialsEmail = (user) => {
    console.log('📧 Email sent (demo only):', {
        to: user.email,
        subject: 'Your Apna Pump Login Credentials',
        body: `Hello ${user.name},\n\nYour login credentials:\nEmail: ${user.email}\nPassword: ${user.password}\n\nPlease keep these credentials secure.`,
    });
};

